module.exports = __webpack_public_path__ + "static/media/double-standard-img2.67d3319c.jpg";